import { useGetCandidates } from '@entities/candidates';
import { Loader, Select, type SelectProps } from '@mantine/core';
import { IconChevronDown } from '@tabler/icons-react';
import { PaginateType } from '@shared/types';
import type { Candidate } from '@entities/vacancy';

export const CandidateSelect = ({ ...props }: SelectProps) => {
  const { data, isLoading } = useGetCandidates({
    filter: {},
    paginate: PaginateType.NONE,
  });

  const candidates = (Array.isArray(data) ? data : data?.data) as
    | Candidate[]
    | undefined;

  return (
    <Select
      data={
        candidates?.map(item => ({
          label: [item.lastName, item.firstName].filter(Boolean).join(' '),
          value: item.id.toString(),
        })) ?? []
      }
      rightSection={
        isLoading ? (
          <Loader size='xs' />
        ) : (
          <IconChevronDown size={20} color='var(--mantine-color-primary-7)' />
        )
      }
      searchable
      {...props}
    />
  );
};
